import React from 'react';
import PixelsIcons from './pixelsIcons';

import ModalLink from '../modals/ModalLink';

import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faTimes from '@fortawesome/fontawesome-pro-light/faTimes';

import classNames from 'classnames';

const PixelSetBadge = ({pixels, name, id, onRemove, loading}) => {
  return (
    <ModalLink to="editPixelSet" params={{pixelId: id}}  className={classNames({loading: loading, "pixel-set-badge": true})}>
      {onRemove && <FA icon={faTimes} onClick={onRemove} /> }
      <span className="pixel-set-badge-name">{name}</span> 
      <span className="pixel-set-badge-pixels"><PixelsIcons pixels={pixels} /></span>
    </ModalLink>
  )
};

export default PixelSetBadge;


// WEBPACK FOOTER //
// ./src/components/PixelSets/pixelSetBadge.js